const TechnologyData = [
     {
    duration: 1100,
    img: "/images/oracle.png",
    name: "Oracle"
  },
   {
    duration: 2300,
    img: "/images/docker.png",
    name: "Docker"
  }
  ,
  {
    duration: 2300,
    img: "/images/Kubernetes.png",
    name: "Kubernetes"

  }
  ,{
    duration: 2300,
    img: "/images/teraform.png",
    name: "Terraform"
  },
  {
    duration: 1200,
    img: "/images/js.png",
    name: "JavaScript"
  },
  {
    duration: 1600,
    img: "/images/ReactJs-removebg-preview.png",
    name: "React JS"
  },
  {
    duration: 1700,
    img: "/images/nextjs.png",
    name: "Next.js"
  },
  {
    duration: 1800,
    img: "/images/node_img.png",
    name: "Node.js"
  },
  {
    duration: 1900,
    img: "/images/express_img.png",
    name: "Express.js"
  },
  {
    duration: 2000,
    img: "/images/mongo_img.png",
    name: "MongoDB"
  },
  {
    duration: 2200,
    img: "/images/MySQL_Server-removebg-preview.png",
    name: "MySQL"
  },
  {
    duration: 2300,
    img: "/images/java-removebg-preview.png",
    name: "Java"
  },
  {
    duration: 2300,
    img: "/images/ts.png",
    name: "TypeScript"
  }
  ,
    {
    duration: 2300,
    img: "/images/python.png",
    name: "Python"

  }
  ,  {
    duration: 2300,
    img: "/images/django.png",
    name: "Django"

  }
  
];

export default TechnologyData;
